import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CharacterFeatureSource, 
  CharacterSheetInterface, 
  CreatureInstance, 
  SummonInstance 
} from "@dndModels";

import ToggleButtonBox from "@components/input/buttons/ToggleButtonBox";
import StringBoxWithReusables from "@dndComponents/StringBoxWithReusables";

interface Props {
  name?: string;
  cfs?: CharacterSheetInterface | CreatureInstance | SummonInstance | CharacterFeatureSource;
  value: string;
  onChange: (value: string) => void; 
  disabled?: boolean;
}

export default function DescriptionBox({
  name = "Description",
  cfs,
  value,
  onChange,
  disabled = false,
  // log_it = false
}: Props) {
  const [show_description, setShowDescription] = useState(true);

  return (
    <div style={{ backgroundColor: "black" }}>
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 12
          }}>
          <ToggleButtonBox
            name={`Show ${name}`}
            value={show_description}
            onToggle={() => {
              setShowDescription(!show_description);
            }}
          />
        </Grid>
        { show_description && 
          <Grid
            size={{
              xs: 12
            }}>
            <StringBoxWithReusables
              name={name}
              value={value}
              cfs={cfs}
              disabled={disabled}
              onChange={onChange}
            />
          </Grid>
        }
      </Grid>
    </div>
  ); 
}
